import { render, staticRenderFns } from "./AsCampoValor.vue?vue&type=template&id=e27120c8&scoped=true&"
import script from "./AsCampoValor.vue?vue&type=script&lang=js&"
export * from "./AsCampoValor.vue?vue&type=script&lang=js&"
import style0 from "./AsCampoValor.vue?vue&type=style&index=0&id=e27120c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27120c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
